// Shape of the cluster-scoped `Sandbox` wrapper XR (gcp.m.ds25.io) as surfaced
// through the generic crossplane-xr fetch (useAppXrResource). Only the fields the
// Backstage cards render are typed; the wrapper passes the rest through to the
// inner XSandbox.

export const SANDBOX_XR_KIND = 'Sandbox';

export interface SandboxXrSpec {
  owner?: string;
  region?: string;
  ttl?: string;
  mode?: string;
  deployDigistore?: boolean;
  database?: {
    mysql?: { size?: string };
    postgres?: { size?: string };
  };
  digistore?: {
    pr?: number;
    chartVersion?: string;
    marketingProxy?: boolean;
  };
}

export interface SandboxXrStatus {
  namespace?: string;
  projectId?: string;
  projectNumber?: string;
  owner?: string;
  adminServiceAccountEmail?: string;
  expiresAt?: string;
  mode?: string;
  frozen?: boolean;
  cluster?: { name?: string };
  gateway?: { ip?: string };
  database?: {
    mysqlConnectionSecret?: string;
    postgresConnectionSecret?: string;
  };
  dns?: {
    domain?: string;
    zone?: string;
    nameServers?: string[];
  };
  digistore?: {
    pr?: number;
    headSha?: string;
    headRef?: string;
    state?: string;
  };
}

// The sandbox storefront is served at www.<dns.domain> behind the managed cert.
export const sandboxStorefrontUrl = (domain?: string): string | undefined =>
  domain ? `https://www.${domain}` : undefined;
